import { FC } from 'react';

import ProductSizeListing from 'components/main/ProductSize';

const ProductSize: FC = () => <ProductSizeListing />;

export default ProductSize;
